/**
 * 产品列表的表格容器,该容器可以让表格的内容根据状态的不同做出变化
 * 比如产品在价格计算中时,所有产品列表处于loading 状态（无 loadingContent 属性的除外）
 * @module ProductTableContainer
 * @see 文档: http://i.shijiebang.net/wiki/pages/viewpage.action?pageId=12394536
 * @author ianva
 */

var React = require('react');
var _ = require("underscore");
var { PropTypes } = require('react');

var ProductTableContainer = React.createClass({
    getDefaultProps(){
        return{
            isLoading: false
        }
    },
    childContextTypes: {
        /**
         * 是否在 loading
         */
        isLoading: PropTypes.bool
    },
    getChildContext: function() {
        return {
            isLoading: this.props.isLoading
        };
    },
    componentWillReceiveProps(nextProps) {
        this.setState({
            isLoading: nextProps
        })
    },
    render(){

        return(
            <table className="product-table is-current-table">
                <tbody>
                {
                    React.Children.toArray(this.props.children).filter((item)=>{
                        return item.type.displayName === 'Cell';
                    })
                }
                </tbody>
            </table>
        )
    }
});

var Cell = React.createClass({

    displayName:'Cell',

    render(){
        return(
            <tr className="">
                <td className="type">
                    {
                        React.Children.toArray(this.props.children).filter((item)=>{
                            return item.type.displayName === 'CellTitle';
                        })
                    }
                </td>
                <td className="content">
                    {
                        React.Children.toArray(this.props.children).filter((item)=>{
                            return item.type.displayName === 'CellContent';
                        })
                    }
                </td>
            </tr>
        )
    }
});

var CellTitle = React.createClass({

    displayName:'CellTitle',
    render(){
        return(
            <div> { this.props.children } </div>
        )
    }
});


var CellContent = React.createClass({

    displayName:'CellContent',

    propTypes: {
        loadingContent: PropTypes.string
    },

    contextTypes: {
        isLoading: React.PropTypes.bool
    },
    render_loading(text){

        return (
            text?
                (
                    <span>
                        <img className="loading-pic" src="//f5.jiejiatech.net/y16/0725/1708/00pgf_o.gif" /> {text}
                    </span>
                ):
                (
                    this.props.children
                )
        )
    },
    render(){

        return(
            <div>
                {
                    this.context.isLoading ? this.render_loading(this.props.loadingContent) : this.props.children
                }
            </div>
        )
    }
});

module.exports = {ProductTableContainer, Cell,CellTitle, CellContent };




/** WEBPACK FOOTER **
 ** ./script/detail/ProductTableContainer.jsx
 **/